import React, { useState, useEffect } from "react";
import { FaListUl } from "react-icons/fa";
import { TbCurrencyRupee } from "react-icons/tb";
import Api from "../../../config/Api";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-multi-date-picker";
import dayjs from "dayjs";
var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

const Counters = () => {
  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      count_date_range: "", // ✅ default: Select filter
    },
  });

  const [counters, setCounters] = useState({});
  const [mode, setMode] = useState("default"); // ✅ default mode

  const getCounters = async (dates) => {
    const body = { ...(dates || {}) };
    const { data } = await Api("dashboard", "POST", body);

    if (data.status === 1) {
      setCounters(data.data || {});
      setMode(data.mode || "filtered"); // backend should send mode
    }
  };

  // ✅ On load: call API WITHOUT dates -> default mode (historical + current released)
  useEffect(() => {
    getCounters({}); // no start_date/end_date
    // eslint-disable-next-line
  }, []);

  const onSubmit = (form) => {
    // ✅ If filter not selected => default
    if (!form.count_date_range) {
      getCounters({});
      return;
    }

    let body = { start_date: "", end_date: "" };

    if (form.count_date_range === "Current Financial Year") {
      const currentMonth = dayjs().month() + 1;
      const currentYear = dayjs().year();

      if (currentMonth >= 4) {
        body.start_date = dayjs(`${currentYear}-04-01`).format("YYYY-MM-DD");
        body.end_date = dayjs(`${currentYear + 1}-03-31`).format("YYYY-MM-DD");
      } else {
        body.start_date = dayjs(`${currentYear - 1}-04-01`).format("YYYY-MM-DD");
        body.end_date = dayjs(`${currentYear}-03-31`).format("YYYY-MM-DD");
      }
    } else if (form.count_date_range === "Daily") {
      body.start_date = dayjs().format("YYYY-MM-DD");
      body.end_date = dayjs().format("YYYY-MM-DD");
    } else if (form.count_date_range === "Weekly") {
      body.start_date = dayjs().startOf("week").add(1, "day").format("YYYY-MM-DD");
      body.end_date = dayjs().endOf("week").add(1, "day").format("YYYY-MM-DD");
    } else if (form.count_date_range === "Current Month") {
      body.start_date = dayjs().startOf("month").format("YYYY-MM-DD");
      body.end_date = dayjs().endOf("month").format("YYYY-MM-DD");
    } else if (form.count_date_range === "Previous Month") {
      body.start_date = dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
      body.end_date = dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
    } else if (form.count_date_range === "Custom Dates") {
      body.start_date = dayjs(form?.count_start_date, "DD MMM YYYY").format("YYYY-MM-DD");
      body.end_date = dayjs(form?.count_end_date, "DD MMM YYYY").format("YYYY-MM-DD");
    }
    console.log("today:", dayjs().format("YYYY-MM-DD"));
    console.log("month:", dayjs().month() + 1);
    console.log("year:", dayjs().year());
    console.log("body:", body);
    getCounters(body);
  };

  const clearFilter = () => {
    setValue("count_date_range", "");
    setValue("count_start_date", "");
    setValue("count_end_date", "");
    getCounters({});
  };

  return (
    <div className="">
      <div className="mb-2">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row g-2">
            <div className="col-12 col-lg-auto text-lg-end">
              <label className="m-0 fw-bold py-lg-1 small">Filters:</label>
            </div>

            <div className="col-lg-2 col-md col-sm-4">
              <select {...register("count_date_range")} className="form-select form-select-sm">
                {/* ✅ default */}
                <option value="">Select filter</option>

                <option value="Current Financial Year">Current Financial Year</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Current Month">Current Month</option>
                <option value="Previous Month">Previous Month</option>
                <option value="Custom Dates">Custom Dates</option>
              </select>
            </div>

            {watch("count_date_range") === "Custom Dates" && (
              <>
                <div className="col-lg-2 col-md col-sm-4 col-6">
                  <Controller
                    control={control}
                    name="count_start_date"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        inputClass="form-control form-control-sm"
                        maxDate={new Date()}
                        placeholder="Select Start Date"
                        format="DD MMM YYYY"
                        editable={true}
                        value={field.value || ""}
                        onChange={(date) => field.onChange(date?.format?.("DD MMM YYYY"))}
                      />
                    )}
                  />
                  {errors.count_start_date && (
                    <div className="error_line">Start date is required</div>
                  )}
                </div>

                <div className="col-lg-2 col-md col-sm-4 col-6">
                  <Controller
                    control={control}
                    name="count_end_date"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        inputClass="form-control form-control-sm"
                        maxDate={new Date()}
                        minDate={dayjs(watch("count_start_date"), "DD MMM YYYY").$d}
                        placeholder="Select End Date"
                        format="DD MMM YYYY"
                        editable={true}
                        value={field.value || ""}
                        onChange={(date) => field.onChange(date?.format?.("DD MMM YYYY"))}
                      />
                    )}
                  />
                  {errors.count_end_date && (
                    <div className="error_line">End date is required</div>
                  )}
                </div>
              </>
            )}

            <div className="col-auto">
              <input type="submit" value="Show" className="btn btn-primary btn-sm px-4" />
            </div>

            {/* <div className="col-auto">
              <button type="button" onClick={clearFilter} className="btn btn-outline-secondary btn-sm px-4">
                Clear
              </button>
            </div> */}
          </div>
        </form>
      </div>

      {/* ✅ DEFAULT MODE: show ONE card + released count */}
      {mode === "default" ? (
        <div className="row g-3 counterboxrow">
          <div className="col-lg-5 col-xl-4">
            <div className="counterbox">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h6 className="fw-bold text-dark">SDRF Count</h6>
                </div>
                <div className="flex-shrink-0 ms-3 counterboxicon">
                  <FaListUl />
                </div>
              </div>

              <div className="mt-2">
                <table className="table table-borderless m-0 table-sm small">
                  <tbody>
                    <tr>
                      <td>Number of Application</td>
                      <th className="text-end" style={{ width: "80px" }}>
                        {counters?.total_released_count || 0}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-lg col-sm-4">
            <div className="counterbox d-flex justify-content-center align-items-center">
              <div className="text-center">
                <div className="counterboxicon mb-3 h1">
                  <TbCurrencyRupee />
                </div>
                <h6 className="mb-2 text-dark">Total Released Amount</h6>
                <div className="fw-bold h5 text-dark">
                  ₹ {Number(counters?.total_released_amount || 0).toLocaleString("en-IN")}
                </div>
                {/* optional breakdown if you want */}
                {/* <div className="small text-muted mt-1">
                  Historical: ₹ {Number(counters?.historical_released_amount || 0).toLocaleString("en-IN")} <br/>
                  Current: ₹ {Number(counters?.current_released_amount || 0).toLocaleString("en-IN")}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        /* ✅ FILTERED MODE: keep your existing full dashboard */
        <div className="">
          <div className="row g-3 counterboxrow">
            {/* SDRF Count Box (unchanged) */}
            <div className="col-lg-5 col-xl-4">
              <div className="counterbox">
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <h6 className="fw-bold text-dark">SDRF Count</h6>
                  </div>
                  <div className="flex-shrink-0 ms-3 counterboxicon">
                    <FaListUl />
                  </div>
                </div>

                <div className="mt-2">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <table className="table table-borderless m-0 table-sm small">
                        <tbody>
                          <tr>
                            <td>Pending</td>
                            <th className="text-end" style={{ width: "50px" }}>
                              {counters?.pending || 0}
                            </th>
                          </tr>
                          <tr>
                            <td>Verified</td>
                            <th className="text-end">{counters?.verified || 0}</th>
                          </tr>
                          <tr>
                            <td>Approved</td>
                            <th className="text-end">{counters?.approved || 0}</th>
                          </tr>
                          <tr>
                            <td>Rejected</td>
                            <th className="text-end">{counters?.rejected || 0}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="flex-grow-1">
                      <table className="table table-borderless m-0 table-sm small">
                        <tbody>
                          <tr>
                            <td>DPA Review</td>
                            <th className="text-end" style={{ width: "50px" }}>
                              {counters?.dpa_review || 0}
                            </th>
                          </tr>
                          <tr>
                            <td>Nodal Officer Review</td>
                            <th className="text-end">
                              {counters?.nodal_officer_review || 0}
                            </th>
                          </tr>
                          <tr>
                            <td>Final Approved</td>
                            <th className="text-end">{counters?.final_approved || 0}</th>
                          </tr>
                          <tr>
                            <td>Pending payment</td>
                            <th className="text-end">{counters?.pending_payment || 0}</th>
                          </tr>
                          <tr>
                            <td>Released</td>
                            <th className="text-end">{counters?.released || 0}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            {/* HOD Approval Amount */}
            <div className="col-lg col-sm-4">
              <div className="counterbox d-flex justify-content-center align-items-center">
                <div className="text-center">
                  <div className="counterboxicon mb-3 h1"><TbCurrencyRupee /></div>
                  <h6 className="mb-2 text-dark">Approved Amount</h6>
                  <div className="fw-bold h5 text-dark">
                    ₹ {Number(counters?.hod_fund_approval_Amount || 0).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>

            {/* Remain Approval (Status 6) */}
            <div className="col-lg col-sm-4">
              <div className="counterbox d-flex justify-content-center align-items-center">
                <div className="text-center">
                  <div className="counterboxicon mb-3 h1"><TbCurrencyRupee /></div>
                  <h6 className="mb-2 text-dark">Amount Pending (DRPS)</h6>
                  <div className="fw-bold h5 text-dark">
                    ₹ {Number(counters?.hod_remain_approval_amount || 0).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>

            {/* Pending (Status 8 + 9) */}
            <div className="col-lg col-sm-4">
              <div className="counterbox d-flex justify-content-center align-items-center">
                <div className="text-center">
                  <div className="counterboxicon mb-3 h1"><TbCurrencyRupee /></div>
                  <h6 className="mb-2 text-dark">Processing Amount</h6>
                  <div className="fw-bold h5 text-dark">
                    ₹ {Number(counters?.hod_fund_pending_amount || 0).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>

            {/* Released */}
            <div className="col-lg col-sm-4">
              <div className="counterbox d-flex justify-content-center align-items-center">
                <div className="text-center">
                  <div className="counterboxicon mb-3 h1"><TbCurrencyRupee /></div>
                  <h6 className="mb-2 text-dark">Released</h6>
                  <div className="fw-bold h5 text-dark">
                    ₹ {Number(counters?.hod_fund_released_amount || 0).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>

            {/* Failed */}
            <div className="col-lg col-sm-4">
              <div className="counterbox d-flex justify-content-center align-items-center">
                <div className="text-center">
                  <div className="counterboxicon mb-3 h1"><TbCurrencyRupee /></div>
                  <h6 className="mb-2 text-dark">Failed Payment</h6>
                  <div className="fw-bold h5 text-dark">
                    ₹ {Number(counters?.hod_failed_payment_amount || 0).toLocaleString("en-IN")}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Counters;